/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetNexoRequestRequest
 */
export interface GetNexoRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof GetNexoRequestRequest
     */
    paymentId: string;
    /**
     * 
     * @type {number}
     * @memberof GetNexoRequestRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof GetNexoRequestRequest
     */
    tabId: string;
    /**
     * 
     * @type {string}
     * @memberof GetNexoRequestRequest
     */
    poiid: string;
    /**
     * 
     * @type {string}
     * @memberof GetNexoRequestRequest
     */
    source: string;
    /**
     * 
     * @type {number}
     * @memberof GetNexoRequestRequest
     */
    tip?: number;
}

/**
 * Check if a given object implements the GetNexoRequestRequest interface.
 */
export function instanceOfGetNexoRequestRequest(value: object): value is GetNexoRequestRequest {
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('tabId' in value) || value['tabId'] === undefined) return false;
    if (!('poiid' in value) || value['poiid'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function GetNexoRequestRequestFromJSON(json: any): GetNexoRequestRequest {
    return GetNexoRequestRequestFromJSONTyped(json, false);
}

export function GetNexoRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNexoRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentId': json['paymentId'],
        'amount': json['amount'],
        'tabId': json['tabId'],
        'poiid': json['poiid'],
        'source': json['source'],
        'tip': json['tip'] == null ? undefined : json['tip'],
    };
}

export function GetNexoRequestRequestToJSON(json: any): GetNexoRequestRequest {
    return GetNexoRequestRequestToJSONTyped(json, false);
}

export function GetNexoRequestRequestToJSONTyped(value?: GetNexoRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentId': value['paymentId'],
        'amount': value['amount'],
        'tabId': value['tabId'],
        'poiid': value['poiid'],
        'source': value['source'],
        'tip': value['tip'],
    };
}

